import React from "react";
import { Search } from "lucide-react";
import { handleIsDiwaliTheme } from "../../../utils/constants/Navbar";
import useZustandStore from "../../../zustandStore/useZustandStore";
import AppSwitcher from "../AppSwitch/AppSwitcher";
import DiwaliGlow from "./DiwaliGlow";
import DiwaliGreeting from "./DiwaliGreeting";

const IS_MAC =
  typeof navigator !== "undefined" && /Mac/i.test(navigator.platform || "");

/** Top bar on desktop above the side nav: logo, search and the app switch. */
const DesktopNav = () => {
  const setOpenCommandPalette = useZustandStore((s) => s.setOpenCommandPalette);
  const isDiwali = handleIsDiwaliTheme();

  return (
    <header
      className={`relative hidden h-[52px] shrink-0 items-center lg:flex ${
        isDiwali
          ? "bg-[linear-gradient(90deg,#fff4e0_0%,#fffaf2_30%,#ffffff_55%,#fff7ea_100%)]"
          : "!border-b bg-white"
      }`}
    >
      {isDiwali && <DiwaliGlow />}
      <div className="relative flex h-full w-[16%] min-w-[248px] shrink-0 items-center gap-2 px-5">
        <img
          src="/static/images/seekho-black.webp"
          alt="Seekho"
          className="w-[95px] object-contain"
          onError={(event) => {
            event.currentTarget.style.display = "none";
          }}
        />
        {isDiwali && <DiwaliGreeting />}
      </div>
      <div className="relative flex min-w-0 flex-1 items-center justify-end gap-3 px-5">
        <button
          type="button"
          onClick={() => setOpenCommandPalette(true)}
          className="flex h-9 w-[280px] items-center gap-2 rounded-lg bg-[#e9e6fa]/50 px-3 text-left text-[12.5px] text-slate-500 transition-colors"
        >
          <Search className="h-3.5 w-3.5 shrink-0 text-[#7f7ad5]" />
          <span className="flex-1 truncate">
            Search by Parent Ad ID or topic
          </span>
          <kbd className="rounded bg-white px-1.5 py-px font-sans text-[10px] font-medium text-[#5b55a8]">
            {IS_MAC ? "⌘K" : "Ctrl K"}
          </kbd>
        </button>
        <span className="h-6 w-px bg-[#d4cff2]" />
        <AppSwitcher />
      </div>
    </header>
  );
};

export default DesktopNav;
